import { useState, useCallback } from "react";

export const useDialog = (initialState = false) => {
  const [open, setOpen] = useState(initialState);
  const [data, setData] = useState(null);

  const handleOpen = useCallback((dialogData = null) => {
    setData(dialogData);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => setData(null), 300); // 等待動畫結束後清除數據
  }, []);

  return {
    open,
    data,
    handleOpen,
    handleClose,
  };
};
